/* Kashmire : chargement automatique de la suite sur les pages collection (07-08/10).
   Le theme est regle sur "bouton charger plus" (templates/collection.json) ; ce script clique
   le bouton tout seul bien avant d'arriver en bas (~1200px), une fine barre de chargement
   s'affiche sous la grille, et les nouvelles pieces apparaissent (kp-reveal).
   08/10 : surveillance par IntersectionObserver (aucun calcul pendant le defilement).
   Le style est dans assets/kp-tweaks.css (section 6). */
(function () {
  if (window.kpAutoLoadInit) return;
  window.kpAutoLoadInit = true;

  var SECTION = '.collection--pagination-click';
  var BOX = SECTION + ' .collection__infinite-trigger';
  var LINK = BOX + ' [data-click-to-load]';
  var DISTANCE = 1200; // px avant le bas de la grille ou l'on lance le chargement
  var busy = false;
  var before = 0;
  var timer = null;
  var near = false;
  var io = null;
  var watched = null;

  function count() {
    return document.querySelectorAll(SECTION + ' .collection__products .product-item').length;
  }

  function state() {
    var box = document.querySelector(BOX);
    var link = document.querySelector(LINK);
    if (box) {
      if (box.classList.contains('kp-has-more') !== !!link) box.classList.toggle('kp-has-more', !!link);
      if (!busy && box.classList.contains('kp-loading')) box.classList.remove('kp-loading');
    }
    // la zone surveillee peut etre remplacee par le theme apres chaque chargement
    if (io && box && box !== watched) {
      if (watched) io.unobserve(watched);
      watched = box;
      io.observe(box);
    }
    return { box: box, link: link };
  }

  function done() {
    busy = false;
    clearTimeout(timer);
    state();
    if (near) window.requestAnimationFrame(load);
  }

  function load() {
    if (busy) return;
    var s = state();
    if (!s.box || !s.link) return;
    busy = true;
    before = count();
    s.box.classList.add('kp-loading');
    clearTimeout(timer);
    timer = setTimeout(done, 10000); // securite si le chargement echoue
    s.link.click();
  }

  function start() {
    var section = document.querySelector(SECTION);
    if (!section) return;
    document.documentElement.classList.add('kp-autoload');

    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        near = entries[entries.length - 1].isIntersecting;
        if (near) load();
      }, { rootMargin: '0px 0px ' + DISTANCE + 'px 0px', threshold: 0 });
    }

    var pending = false;
    var mo = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(function () {
        pending = false;
        if (busy && count() > before) done();
        else state();
      });
    });
    mo.observe(section, { childList: true, subtree: true });

    state();
    if (!io) {
      // navigateur ancien : simple verification au defilement
      var ticking = false;
      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          ticking = false;
          var s = state();
          near = !!s.box && s.box.getBoundingClientRect().top - window.innerHeight < DISTANCE;
          if (near) load();
        });
      }, { passive: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
